<template>
    <div id="viewSkills">
        <div>
            <p class="title black">SKILLS</p>
            <p class="title black">SKILLS</p>
        </div>
        <div id="skillBox">
            <div>
                <h2>Familiar</h2>
                <ul>
                    <li>
                        <div><img src="../assets/skills/nextjs.png" alt="logo" /></div>
                        <span>NEXT.js</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/vue.png" alt="logo" /></div>
                        <span>Vue.js</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/html.png" alt="logo" /></div>
                        <span>HTML</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/css.png" alt="logo" /></div>
                        <span>CSS</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/bootstrap.png" alt="logo" /></div>
                        <span>Bootstrap</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/springboot.png" alt="logo" /></div>
                        <span>SpringBoot</span>
                    </li>
                </ul>
            </div>
            <div>
                <h2>Tried</h2>
                <ul>
                    <li>
                        <div><img src="../assets/skills/spring.png" alt="logo" /></div>
                        <span>Spring</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/mysql.png" alt="logo" /></div>
                        <span>MySQL</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/postgresql.png" alt="logo" /></div>
                        <span>PostgreSQL</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/sass.png" alt="logo" /></div>
                        <span>SASS</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/docker.png" alt="logo" /></div>
                        <span>Docker</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/azure.png" alt="logo" /></div>
                        <span>Azure</span>
                    </li>
                </ul>
            </div>
            <div>
                <h2>Language</h2>
                <ul>
                    <li>
                        <div><img src="../assets/skills/javascript.png" alt="logo" /></div>
                        <span>JavaScript</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/typescript.png" alt="logo" /></div>
                        <span>TypeScript</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/java.png" alt="logo" /></div>
                        <span>Java</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/kotlin.png" alt="logo" /></div>
                        <span>Kotlin</span>
                    </li>
                    <li>
                        <div><img src="../assets/skills/python.png" alt="logo" /></div>
                        <span>Python</span>
                    </li>
                </ul>
            </div>
        </div>
    </div>
</template>
<script>
export default {};
</script>
<style>
#viewSkills {
    margin-top: 240px;
}

#viewSkills > div:first-child {
    position: relative;
}
#viewSkills > div > p:first-child {
    margin: 0;
    color: #edb352;
}
#viewSkills > div > p:last-child {
    position: absolute;
    margin: 0;
    top: 6px;
    left: 8px;
    text-shadow: -1px 0 #edb352, 0 1px #edb352, 1px 0 #edb352, 0 -1px #edb352;
    color: white;
    z-index: -1;
}
#skillBox {
    margin-top: 50px;
    margin-left: 100px;
}
#skillBox::after {
    content: "";
    display: block;
    clear: both;
}
#skillBox > div {
    float: left;
}
#skillBox h2 {
    font-size: 1.2em;
}
#skillBox > div {
    width: 33%;
}
#skillBox li {
    height: 72px;
    margin-bottom: 20px;
}
#skillBox li::after {
    display: block;
    content: "";
    clear: both;
}
#skillBox li > span {
    float: left;
    line-height: 72px;
}
#skillBox li > div {
    margin-right: 20px;
    float: left;
    width: 56px;
    height: 56px;
    padding: 2px;
    position: relative;
    border-radius: 10px;
    box-shadow: -1px 2px 8px rgba(0, 0, 0, 0.1);
}
#skillBox li > div > img {
    display: block;
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
}
ul {
    list-style: none;
    margin: 0;
    padding: 0;
}
</style>
